function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  fill: "currentColor",
  height: "1em",
  width: "1em",
  viewBox: "64 64 896 896"
}, props), React.createElement("path", {
  d: "M159.2 64.5a51.45 51.45 0 00-71.575 0l-47.8 46.7a48.675 48.675 0 00-.075 69.875L364.5 500 39.75 818.925a48.675 48.675 0 00.075 69.875l47.8 46.7c19.75 19.325 51.8 19.325 71.575 0L569 535c19.75-19.325 19.75-50.625 0-69.95zm391.175 0a51.45 51.45 0 00-71.575 0L431 111.2a48.675 48.675 0 00-.075 69.875L755.675 500l-324.75 318.925A48.675 48.675 0 00431 888.8l47.8 46.7c19.75 19.325 51.8 19.325 71.575 0l409.8-400.5c19.75-19.325 19.75-50.625 0-69.95z"
})));